import {
  INPUT_CHANGE,
  DATE_CHANGE,
  INPUT_UI_CHANGE,
  INIT_UI,
} from './constants'

export const initUi = (value) => {
  return {
    type: INIT_UI,
    value,
  }
}

export const changeInput = (label, text) => {
  return {
    type: INPUT_CHANGE,
    label,
    text,
  }
}

export const changeDate = (label, date) => {
  return {
    type: DATE_CHANGE,
    label,
    date,
  }
}

export const inputUiChange = (label, text) => {
  return {
    type: INPUT_UI_CHANGE,
    label,
    text
  }
}
